import { render, staticRenderFns } from "./FormatReferencesListBoxSelector.vue?vue&type=template&id=ac4a2ac4&scoped=true&"
import script from "./FormatReferencesListBoxSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatReferencesListBoxSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferencesListBoxSelector.vue?vue&type=style&index=0&id=ac4a2ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4a2ac4",
  null
  
)

export default component.exports